<template>
<div class="chapter">
<div class="inner_page">
<h1>Amazing Stories</h1>
<h2 class="sigil_not_in_toc">Volume 63</h2>
<h2 class="sigil_not_in_toc">Alan Edward Nourse</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?30cfc61c